<template>
    <div class="row match-height">
        <div class="col-lg-3 col-md-3 col-12 mx-auto">
            <label class="text-title-green driver-licence-txt" for="driver-licence-image">
                {{ localizationStore.translate('driver.licence.image.label') }}
            </label>
            <lincence-state-id></lincence-state-id>
        </div>
        <div class="col-lg-3 col-md-3 col-12">
            <label class="text-title-green driver-licence-txt" for="ssc-image">
               {{ localizationStore.translate('ssc.image.label') }}
            </label>
            <social-security-card-upload></social-security-card-upload>
        </div>
        <div class="col-lg-3 col-md-3 col-12 mx-auto">
            <label class="text-title-green driver-licence-txt" for="address-verification-image">
                {{ localizationStore.translate('address.verification.image.label') }}
            </label>
            <address-verification-upload></address-verification-upload>
        </div>
        <div class="col-lg-3 col-md-3 col-12 mx-auto">
            <label class="text-title-green driver-licence-txt" for="address-verification-image">
                {{ localizationStore.translate('id.theft.affidavit') }}
            </label>
            <upload-id-theft-affidavit></upload-id-theft-affidavit>
        </div>
    </div>
</template>
<script>
import {ref} from 'vue'
import { useLocalizationStore } from '../../../../stores/LocalizationStore.js'
import LincenceStateId from './LincenceStateId.vue'
import SocialSecurityCardUpload from './SocialSecurityCardUpload.vue'
import AddressVerificationUpload from './AddressVerificationUpload.vue'
AddressVerificationUpload
export default{
    name:'PersonalInfoModal',
    components:{
        LincenceStateId,AddressVerificationUpload,SocialSecurityCardUpload
    },
    setup(){
        return {
            localizationStore : useLocalizationStore(),
        }
    },
    watch: {

    },
    methods:{

    }
}
</script>
<style>
#upload_label{
    height: 29px;
    width: 100%;
    cursor: pointer;
    background: #4b9a5e;
    border-radius: 5px;
    color: white;
    line-height: 29px;
    text-align: center;
    font-size: 13px;
}
.image-container{
    position: relative;
    width: 70%;
    height: 150px;
    overflow: hidden;
}
.image-container .image-fluid{
    display: block;
    position: relative;
    margin: 0 auto;
    display: block;
}
.image-delete{
    position: absolute;
    bottom: 0px;
    height: 25px;
    background: #ea5455;
    width: 100%;
    color: white;
    line-height: 25px;
    text-align: center;
    visibility: hidden;
    cursor: pointer;
}
.image-container:hover .image-delete{
    visibility: visible;
}
.driver-licence-txt{
    font-size: 14px;
}
</style>

